<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>
<!-- <script src="https://unpkg.com/element-ui/lib/index.js"></script> -->
<script>

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      loading: null,
    }
  },
  mounted() {
    //el-icon-loading
    this.$bus.$on("fn_loadingYes", () => {
      console.log("正在加载");
      this.loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
    });
    this.$bus.$on("fn_loadingNo", () => {
      this.loading.close();
    });
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

.el-dialog__headerbtn .el-dialog__close {
  color: rgb(30, 162, 139);
}

.el-button--primary {
  background-color: #2ad199;
  border-color: #2ad199;
}

.el-button--primary:hover {
  background-color: #2ad199;
  border-color: #2ad199;
}

.el-calendar-table .el-calendar-day {
  height: 30px;
  padding: 0;
}

.el-calendar-day > span {
  display: inline-block;
  height: 100%;
  width: 100%;
  line-height: 30px;
}

.el-icon-delete {
  color: red !important;
}

.el-icon-edit {
  color: #56b9a8 !important;
}

.el-icon-s-operation {
  color: #56b9a8 !important;
}

.el-textarea__inner {
  resize: none;
}

.el-dialog__header {
  text-align: center;
  background-color: #2ad199;
}

.el-dialog__title {
  color: white !important;
  font-weight: 550;
}

.el-tooltip__popper.is-light {
  color: #bebebe;
  border: 1px solid #bebebe;
}

.el-tooltip__popper.is-dark {
  background-color: #1ea28b;
}

.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #1ea28b !important;
}

/* .el-tooltip__popper.is-dark {
  background-color: white;
  color:#9A9A9A;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: white !important;
} */
.popper__arrow::after {
  border: #1ea28b;
}

.wholeDiv {
  width: 100%;
  height: 100%;
  min-width: 800px;
  padding: 10px 10px;
  box-sizing: border-box;
  min-width: 1689px;
}

.el-button--medium {
  border: 1px solid rgb(147, 210, 243);
  background-color: rgb(218, 247, 255);
  color: rgb(22, 119, 210);
  border-radius: 8px;
  padding: 7px 20px;
  font-size: 15px;
  width: 142px;
  height: 30px;
}

body > .el-loading-mask > .el-loading-spinner {
  /*background: url(./assets/iamges/加载中loading.png) no-repeat center center;*/
  height: 360px;
  top: 35%;
}

.el-table::-webkit-scrollbar {
  width: 0;
}
</style>






// WEBPACK FOOTER //
// src/App.vue